const CompanyArr = {
	test: {
		requestUrl: ' http://8.149.132.117:8070',
		title: '测试环境',
		name: '测试',
		doMainId: '0',
		wssUrl: 'ws://8.149.132.117:9002'    //wss地址（含ssl证书域名）
	},
	v3: {
		requestUrl: 'https://gt.yimixingche.com',
		// requestUrl: 'http://192.168.9.241:8070',
		title: '一米停车',
		name: '一米智慧停车',  //岗亭登录 时  显示的品牌（平台）名称
		doMainId: '0',    //域名id，请登录后台 查看对应域名id（如果没有请新建登录域名后可获取域名id）
		wssUrl: 'wss://gt.yimixingche.com',    //wss地址（含ssl证书域名）
		// wssUrl: 'ws://192.168.9.241:9002',
		logoText: '智慧城市专家'    //登录二维码底部文字
	}
}

module.exports = CompanyArr.v3
